/* Warehouse Bold — custom kits in the cart */
(function () {
  'use strict';

  /* ⚠ ONE delegated listener on document, behind a run-once flag.
     cart.js replaces the innerHTML of #MainCart-{sectionId} and the drawer
     containers on EVERY cart mutation, then dispatches cart:updated after the
     swap. Anything bound inside those containers dies silently on the first
     quantity change, and a <script> inserted via innerHTML never executes at
     all — so binding here, once, on a node that survives, is the only shape
     that keeps working. Same pattern as the cart page's tab strip. */
  if (window.__wbKitCart) return;
  window.__wbKitCart = true;

  function routes() {
    return (window.FoxTheme && FoxTheme.routes) || {};
  }

  function removeKit(kid, btn) {
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }
    fetch((routes().cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Zero every line carrying this kit id, keyed by line KEY.
           Keyed updates, never positional: the cart page renders rows grouped
           by dispatch promise rather than in cart order, so a positional
           updates[] array would zero whichever lines happened to sit at those
           indexes. */
        var updates = {};
        var found = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.properties && it.properties._kit_id === kid) {
            updates[it.key] = 0;
            found++;
          }
        }
        if (!found) return null;

        var sections = [];
        document.dispatchEvent(new CustomEvent('cart:grouped-sections', { detail: { sections: sections } }));

        return fetch(routes().cart_update_url || '/cart/update', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            updates: updates,
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
      });
  }

  /* ── the kit, big enough to look at ─────────────────────────────────────
     The thumbnail tells you it is a kit. This tells you what is IN it, which
     is the question a picture of a kit is actually there to answer.

     Cloned from the band rather than re-rendered: the markup on the page is
     already the kit, so there is nothing to keep in sync and nothing to fetch.
     Only the plate width changes — the pieces reflow into it by themselves. */
  var closeModal = null;

  function openPhoto(kid, source) {
    if (closeModal) closeModal();
    var band = source.closest('[data-wb-kit]');
    var photo = band && band.querySelector('.wb-kitphoto');
    if (!photo) return;

    var name = band.querySelector('.cart-item__title, .wb-kitband__name');
    var meta = band.querySelector('.cart-item__option-value, .wb-kitband__count');

    var wrap = document.createElement('div');
    wrap.className = 'wb-kitmodal';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');

    var box = document.createElement('div');
    box.className = 'wb-kitmodal__box';

    var head = document.createElement('div');
    head.className = 'wb-kitmodal__head';
    if (name) {
      var h = document.createElement('span');
      h.className = 'wb-kitmodal__name';
      h.textContent = name.textContent.trim();
      head.appendChild(h);
      wrap.setAttribute('aria-label', h.textContent);
    }
    if (meta) {
      var m = document.createElement('span');
      m.className = 'wb-kitmodal__meta';
      m.textContent = meta.textContent.trim();
      head.appendChild(m);
    }

    /* The theme's own close control, so this dismisses the way every other
       drawer and modal on the site does. */
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'drawer__close-btn z-1';
    x.setAttribute('aria-label', 'Close');
    x.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" ' +
      'class="icon icon-close icon--large icon--thick" fill="none" viewBox="0 0 24 24">' +
      '<path d="M18.75 5.13496L5.25 18.8544" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M18.75 18.8544L5.25 5.13496" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var clone = photo.cloneNode(true);
    clone.removeAttribute('aria-hidden');
    /* ⚠ The thumbnail carries its plate width as an INLINE style, which would
       follow the clone in and pin the modal to a 104px column. Inline beats the
       stylesheet, so it has to be cleared rather than overridden. */
    clone.style.width = '';
    /* ⚠ Sharper sources. The plate serves its pieces at width=48, which is
       right for a 112px thumbnail and a 4x upscale in here — the pliers draw
       nearly 200px wide and came out visibly soft. Rewriting the width on the
       clone keeps the thumbnail light and only pays for detail where it shows.
       Requests above a file's own width are capped by the CDN, so the small
       cut-outs cost nothing extra. */
    Array.prototype.forEach.call(clone.querySelectorAll('img'), function (im) {
      var src = im.getAttribute('src') || '';
      if (src.indexOf('width=') >= 0) im.setAttribute('src', src.replace(/width=\d+/, 'width=400'));
    });
    /* Bigger pieces AND a wider plate — raising only the height would spill a
       long kit off the side. */
    var h0 = parseInt(getComputedStyle(photo).getPropertyValue('--wb-piece-h'), 10) || 24;
    clone.style.setProperty('--wb-piece-h', Math.round(h0 * 2.2) + 'px');
    clone.style.setProperty('--wb-piece-gap', (h0 * 2.2 < 20 ? 2 : 3) + 'px');

    box.appendChild(x); box.appendChild(head); box.appendChild(clone);
    wrap.appendChild(box);
    document.body.appendChild(wrap);

    /* Square it. Left at full width the pieces run out as one long band, which
       tells you the count and nothing about the kit. Area is roughly preserved
       as the plate narrows — the same pieces just wrap into more rows — so
       sqrt(width x height) converges on a square in two or three passes,
       whatever the kit holds. Measured rather than derived: the pieces are
       three different aspects and some rows are short.

       ⚠ Only once the pictures are IN. Each piece is width:auto against a set
       height, so before it loads an <img> is zero wide and the plate measures
       as a stack of empty rows — squaring against that converged on a tall
       column. Re-run on the last load, with a timeout in case one never
       arrives. */
    /* ⚠ Measured from the OVERLAY, not the box. The box has no width of its
       own — it shrinks to its content — so asking it how much room there is
       returns however wide the plate already happens to be, and the plate
       could then never grow. 62rem is the box's max-width, 48 its padding. */
    var avail = Math.max(240, Math.min(620, wrap.clientWidth - 64) - 48);

    function square() {
      clone.style.width = avail + 'px';
      for (var pass = 0; pass < 5; pass++) {
        var w = clone.offsetWidth, hh = clone.offsetHeight;
        if (!w || !hh) return;
        var side = Math.max(200, Math.min(avail, Math.round(Math.sqrt(w * hh))));
        if (Math.abs(side - w) < 6) return;
        clone.style.width = side + 'px';
      }
    }

    var imgs = clone.querySelectorAll('img');
    var pending = 0, settled = false;
    /* Squaring finds the square that the CURRENT piece size happens to make,
       which for a small kit is a small square in a large modal. Grow the
       pieces to fill the space and square again — the shape is preserved
       because both dimensions scale together. */
    function fill() {
      square();
      var w = clone.offsetWidth;
      if (!w) return;
      var target = Math.min(avail, 520);
      if (w < target * 0.9) {
        var h = parseInt(clone.style.getPropertyValue('--wb-piece-h'), 10) || 24;
        clone.style.setProperty('--wb-piece-h', Math.max(6, Math.round(h * target / w)) + 'px');
        square();
      }
    }

    function done() {
      if (settled) return;
      settled = true;
      fill();
    }
    Array.prototype.forEach.call(imgs, function (im) {
      if (im.complete && im.naturalWidth) return;
      pending++;
      im.addEventListener('load', function () { if (--pending <= 0) done(); }, { once: true });
      im.addEventListener('error', function () { if (--pending <= 0) done(); }, { once: true });
    });
    square();
    if (pending === 0) done(); else setTimeout(done, 2500);

    function onKey(ev) { if (ev.key === 'Escape') closeModal(); }
    closeModal = function () {
      document.removeEventListener('keydown', onKey);
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
      closeModal = null;
      try { source.focus(); } catch (e) {}
    };
    document.addEventListener('keydown', onKey);
    wrap.addEventListener('click', function (ev) {
      if (ev.target === wrap || ev.target === x || x.contains(ev.target)) closeModal();
    });
    x.focus();
  }

  /* ── the thumbnail always fits its square ────────────────────────────────
     The plate's height is whatever its contents come to: more lines, more
     rows, and the pliers row is twice the height of a fastener row. Sized by
     a constant it fitted the kit it was tuned against and clipped the next one
     — a six-part kit lost its pliers off the bottom.

     So it is measured instead. Scale down only, and only when it does not
     fit, which leaves small kits drawn at full size and lets big ones zoom out
     rather than lose anything.

     ⚠ After the images load. Each piece is width:auto against a set height, so
     until a picture arrives it is zero wide and the plate measures as a stack
     of empty rows — the same trap the modal hit. */
  function fitPhoto(ph) {
    var box = ph.closest('.wb-kititem__media');
    if (!box) return;
    var cs = getComputedStyle(box);
    var innerH = box.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    var innerW = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    /* ⚠ Bail WITHOUT touching the transform. A drawer that has not been opened
       yet measures zero, and clearing the scale on the way out is what left a
       previously-fitted photo overflowing the moment it became visible. */
    if (!innerH || !innerW) return;
    var prev = ph.style.transform;
    ph.style.transform = 'none';
    var h = ph.offsetHeight, w = ph.offsetWidth;
    if (!h || !w) { ph.style.transform = prev; return; }
    var s = Math.min(1, innerH / h, innerW / w);
    ph.style.transformOrigin = 'center';
    if (s >= 0.995) { ph.style.transform = ''; return; }
    ph.style.transform = 'scale(' + s.toFixed(3) + ')';

    /* ⚠ Scaling alone is not enough. A transform is visual, so the grid still
       lays the plate out at its FULL height — taller than the box — and places
       it accordingly. Shrinking about the centre then leaves the picture
       sitting low, which is how the pliers stayed cut off even at a scale that
       should have fitted. Measure where it actually landed and nudge it back
       inside; cheaper and more certain than reasoning about how the grid
       aligns an item bigger than its track. */
    var b = box.getBoundingClientRect(), r = ph.getBoundingClientRect();
    var top = b.top + parseFloat(cs.paddingTop);
    var bottom = b.bottom - parseFloat(cs.paddingBottom);
    var dy = 0;
    if (r.top < top) dy = top - r.top;
    else if (r.bottom > bottom) dy = bottom - r.bottom;
    if (dy) ph.style.transform = 'translateY(' + dy.toFixed(1) + 'px) scale(' + s.toFixed(3) + ')';
  }

  function fitAllPhotos() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.wb-kititem__media .wb-kitphoto'),
      function (ph) {
        var imgs = ph.querySelectorAll('img');
        var pending = 0, ran = false;
        function go() { if (ran) return; ran = true; fitPhoto(ph); }
        Array.prototype.forEach.call(imgs, function (im) {
          if (im.complete && im.naturalWidth) return;
          pending++;
          im.addEventListener('load', function () { if (--pending <= 0) go(); }, { once: true });
          im.addEventListener('error', function () { if (--pending <= 0) go(); }, { once: true });
        });
        fitPhoto(ph);
        if (pending === 0) go(); else setTimeout(go, 2500);
      }
    );
  }

  /* ⚠ The drawer is in the DOM long before it is ever opened, and a hidden box
     has no size to fit against. Watching the box means the fit happens the
     moment it gets one — on open, on resize, on a re-render — instead of once
     at load when the answer is always zero. */
  var RO = window.ResizeObserver ? new ResizeObserver(function (entries) {
    entries.forEach(function (en) {
      var ph = en.target.classList.contains('wb-kitphoto')
        ? en.target
        : en.target.querySelector('.wb-kitphoto');
      if (!ph) return;
      var box = ph.closest('.wb-kititem__media');
      if (box && box.clientHeight) fitPhoto(ph);
    });
  }) : null;

  /* ⚠ BOTH the box and the plate are watched, because the two things that
     decide whether it fits arrive at different moments and each pass on its
     own missed. The box goes 0 → 112 when the drawer opens, which is usually
     BEFORE the pictures land; the plate grows to its real height when they do,
     which is usually AFTER the box has stopped changing. Watching one caught
     the kit at exactly the wrong instant every time.

     No feedback loop: a transform is visual, so scaling the plate does not
     change the layout size the observer reports. */
  function watchPhotos() {
    if (!RO) return;
    Array.prototype.forEach.call(document.querySelectorAll('.wb-kititem__media'), function (box) {
      if (box.__wbkWatched) return;
      box.__wbkWatched = true;
      RO.observe(box);
      var ph = box.querySelector('.wb-kitphoto');
      if (ph) RO.observe(ph);
    });
  }

  function refresh() { watchPhotos(); fitAllPhotos(); }

  /* ⚠ ResizeObserver is the right mechanism and not a sufficient one. The two
     moments that matter — the drawer gaining a size, and the pictures landing —
     can both pass without a callback anywhere the observer is not running, and
     a plate that misses them stays at whatever it measured while hidden. A few
     timed passes after anything that opens a cart cost three measurements and
     do not depend on observers running at all. */
  function scheduleFit() { [80, 400, 1200, 2600].forEach(function (ms) { setTimeout(fitAllPhotos, ms); }); }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[aria-controls*="cart" i], [href*="/cart"], [data-cart-drawer-trigger], .header__cart, [data-wb-kitphoto-open]')) {
      scheduleFit();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); scheduleFit(); });
  } else {
    refresh(); scheduleFit();
  }
  window.addEventListener('resize', function () { setTimeout(fitAllPhotos, 120); });

  /* ── a kit counts as one item ───────────────────────────────────────────
     cart.item_count sums line quantities, so a three-line kit beside a spool
     of lockwire reported four when the customer can see two things. Liquid
     handles first paint (snippets/wb-kit-count); this is the AJAX path.

     ⚠ Applied on the NEXT TICK rather than inline. The theme's own <cart-count>
     subscribes to the same event from its connectedCallback, so whether it
     runs before or after this depends on when the element upgraded — a race.
     Correcting after the current task has drained means it does not matter. */
  function kitAdjusted(cart) {
    var units = 0, seen = {}, kits = 0;
    (cart.items || []).forEach(function (it) {
      var kid = it.properties && it.properties._kit_id;
      if (!kid) return;
      units += it.quantity;
      if (!seen[kid]) { seen[kid] = 1; kits++; }
    });
    return Math.max(0, (cart.item_count || 0) - units + kits);
  }

  function paintCount(n) {
    Array.prototype.forEach.call(document.querySelectorAll('cart-count'), function (el) {
      var shown = n > 99 ? '99+' : String(n);
      if (el.dataset.type === 'blank') shown = '(' + shown + ')';
      if (el.classList.contains('cart-count--absolute') && n > 99) {
        el.innerHTML = '<span class="text-sm-extra">' + shown + '</span>';
        el.classList.add('cart-count--small-medium');
      } else {
        el.innerText = shown;
        el.classList.remove('cart-count--small-medium');
      }
      el.hidden = n === 0;
    });
    document.documentElement.classList[n === 0 ? 'remove' : 'add']('cart-has-items');
  }

  (function hookCount(tries) {
    if (!(window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS)) {
      if (tries > 0) setTimeout(function () { hookCount(tries - 1); }, 120);
      return;
    }
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!ev || !ev.cart || ev.cart.errors) return;
      var n = kitAdjusted(ev.cart);
      setTimeout(function () { paintCount(n); refresh(); scheduleFit(); }, 0);
    });
  })(40);

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-wb-kitphoto-open]');
    if (open) {
      e.preventDefault();
      openPhoto(open.getAttribute('data-wb-kitphoto-open'), open);
      return;
    }
    var btn = e.target.closest('[data-wb-kitremove]');
    if (!btn) return;
    e.preventDefault();
    removeKit(btn.getAttribute('data-wb-kitremove'), btn);
  });
})();
